// extracted by mini-css-extract-plugin
export default {"clientSec":"client_clientSec__kw3sw"};